
var ol = {};

export default ol;